
import { useState,useEffect } from "react";
import { usePatientQueue } from "../hooks/usePatientQueue.js";

import DashboardTabs from "../components/DashboardTabs.js";

const initialForm = {
  patientName:     "",
  patientEmail:    "",
  doctorName:      "Dr. Sadhana Kumar",
  appointmentTime: "",
};

export default function InvitePage() {
  const { sendInvite } = usePatientQueue();

  const [form,    setForm]    = useState(initialForm);
  const [status,  setStatus]  = useState("idle"); // idle|sending|success|error
  const [result,  setResult]  = useState(null);
  const [errMsg,  setErrMsg]  = useState("");

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  useEffect(() => {
    // Reset form and status when component mounts
    setForm(initialForm);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setErrMsg("");
    try {
      const data = await sendInvite(form);
      setResult(data);
      setStatus("success");
      setForm(initialForm);
    } catch (err) {
      setErrMsg(err.message);
      setStatus("error");
    }
  };

  return (
    <div className="container">
      {/* <DashboardTabs  name={'vinvite'} /> */}

   
    <div className="d-flex justify-content-center align-items-center" >

    
    <div className="invite-page" style={{ minWidth:500,  maxWidth: 600, width: "100%", padding: 16, marginTop: 32, marginBottom: 32 }}>
      <div >
        <div><h3 className="queue-title mb-3 ">Virtual Visit</h3> </div>
        
      </div>
      {/* <div className="my-4" >
        <div className="alert alert-warning" role="alert" style={{ textAlign: "left", marginBottom: 16 }}>
          The patient will receive an email with a secure link to their virtual waiting room.
        </div>
      </div> */}
      <div className="">
        {status === "success" ? (
          <div className="invite-success">
            {result?.emailSent === false ? (
              <>
                <span className="success-icon" aria-hidden="true">⚠️</span>
                <h2>Session created — email not delivered</h2>
                <div className="alert alert-warn" role="alert" style={{ textAlign: "left", marginBottom: 16 }}>
                  {result.warning ?? "SES could not send the email. This is usually because the recipient address is not verified in SES sandbox mode, or the FROM_EMAIL is not verified."}
                </div>
                <p>Share the join link below with the patient directly:</p>
              </>
            ) : (
              <>
                <span className="success-icon" aria-hidden="true">✅</span>
                <h2>Invite sent!</h2>
                <p>
                  An email has been sent to <strong>{form.patientEmail}</strong>.
                </p>
              </>
            )}
            <div className="invite-link-box">
              <span className="link-label">Patient join link</span>
              <a
                href={result?.joinUrl}
                target="_blank"
                rel="noreferrer"
                className="link-value"
              >
                {result?.joinUrl}
              </a>
              <button
                className="btn btn-ghost btn-sm"
                style={{ marginTop: 8 }}
                onClick={() => navigator.clipboard.writeText(result?.joinUrl ?? "")}
                aria-label="Copy join link to clipboard"
              >
                📋 Copy link
              </button>
            </div>
            <button
              className="btn btn-primary"
              onClick={() => { setStatus("idle"); setResult(null); }} style={{ backgroundColor: '#0b5ed7' }}
            >
              Send Again
            </button>
          </div>
        ) : (
          <form className="invite-form" onSubmit={handleSubmit} noValidate>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="patientName">Patient name</label>
                <input
                  id="patientName"
                  name="patientName"
                  type="text"
                  placeholder="Patient Name"
                  value={form.patientName}
                  onChange={handleChange}
                  required
                  autoComplete="off"
                />
              </div>
              <div className="form-group">
                <label htmlFor="patientEmail">Patient email</label>
                <input
                  id="patientEmail"
                  name="patientEmail"
                  type="email"
                  placeholder=""
                  value={form.patientEmail}
                  onChange={handleChange}
                  required
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="doctorName">Doctor name</label>
                <input
                  id="doctorName"
                  name="doctorName" readOnly
                  type="text"
                  placeholder="Dr. Sadhana Kumar"
                  value={form.doctorName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="appointmentTime">Appointment date &amp; time</label>
                <input
                  id="appointmentTime"
                  name="appointmentTime"
                  type="datetime-local"
                  value={form.appointmentTime}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {status === "error" && (
              <div className="form-error" role="alert">
                <span aria-hidden="true">⚠️</span> {errMsg}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary btn-full" style={{ backgroundColor: '#0b5ed7' }}
              disabled={status === "sending"}
            >
              {status === "sending" ? "Sending…" : "Send Notification"}
            </button>
          </form>
        )}
      </div>
    </div>
    </div> </div>

  );
}
